<template>
  <div class="categories-container">
    <h2 class="title">Select a Category</h2>
    <div class="category-grid">
      <!-- Grid layout for categories -->
      <div
        v-for="cat in categories"
        :key="cat"
        class="category-card"
        :class="{ clickable: cat === 'Fashion' }"
        @click="onCategoryClick(cat)"
      >
        {{ cat }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Categories',
  data() {
    return {
      categories: [
        'Fashion',
        'Beauty',
        'Home & Household',
        'Toys',
        'Jewelry & Watches',
        'Multimedia',
        'Stationery',
        'Sport',
        'Baggage',
        'Wine & Food',
        'Gifts',
      ],
    };
  },
  methods: {
    onCategoryClick(cat) {
      // Only navigate to the Catalog for "Fashion"
      if (cat === 'Fashion') {
        this.$emit('open-catalog');
      }
      // Otherwise, do nothing (or show a message/toast)
    },
  },
};
</script>

<style scoped>
.categories-container {
  max-width: 1200px;
  margin: 8px auto; /* Adjust if you have a fixed header */
  padding: 20px;
  text-align: center;
}

.title {
  font-size: 2rem;
  margin-bottom: 40px;
  color: #2c3e50;
}

/* 
  Create a grid layout with explicit responsive behavior
*/
.category-grid {
  display: grid;
  /* Responsive grid layout */
  grid-template-columns: 1fr;          /* Mobile: 1 column */
  gap: 20px;
  padding: 0 20px;
}

/* Responsive breakpoints */
@media (min-width: 480px) {
  .category-grid {
    grid-template-columns: repeat(2, 1fr); /* Small: 2 columns */
  }
}

@media (min-width: 768px) {
  .category-grid {
    grid-template-columns: repeat(3, 1fr); /* Medium: 3 columns */
  }
}

@media (min-width: 992px) {
  .category-grid {
    grid-template-columns: repeat(4, 1fr); /* Large: 4 columns */
  }
}

@media (min-width: 1200px) {
  .category-grid {
    grid-template-columns: repeat(5, 1fr); /* XL: 5 columns */
  }
}

.category-card {
  background-color: #fff;
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 40px 20px;
  cursor: default;
  font-size: 1.1rem;
  font-weight: 500;
  color: #444;
  box-shadow: 0 2px 4px rgba(0,0,0,0.08);
  transition: transform 0.3s, box-shadow 0.3s;
  user-select: none;
}

.category-card.clickable {
  cursor: pointer;
}

.category-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 6px 12px rgba(0,0,0,0.1);
}
</style>